<template>
  <div class="templateAdd">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>凭证模板 </div>
        </template>
        <div class="collapse-content">
          <base-form
            v-model="baseData"
            :options="baseDataOptions"
            ref="baseData"
            :rules="rules"
            @input="handleChangeBaseData"
            :disabled="$route.query.type == 'query'"
            label-width="105px"
          ></base-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>凭证模板明细 </div>
        </template>
        <div class="collapse-content">
          <vxe-toolbar>
            <template v-slot:buttons>
              <vxe-button icon="fa fa-plus" @click="insertEvent()">新增</vxe-button>
            </template>
          </vxe-toolbar>

          <vxe-table
            border
            row-key
            highlight-hover-row
            ref="xTable"
            height="500"
            :data="tableData"
            @cell-dblclick="cellDBLClickEvent"
          >
            <vxe-table-column type="seq" width="60"></vxe-table-column>
            <vxe-table-column title="操作" width="100" show-overflow>
              <template v-slot="{ row }">
                <vxe-button type="text" name="修改" @click="editEvent(row)">修改</vxe-button>
                <vxe-button type="text" name="删除" @click="removeEvent(row)">删除</vxe-button>
              </template>
            </vxe-table-column>
            <vxe-table-column field="entryCode" title="分录类型代码" width="100"></vxe-table-column>
            <vxe-table-column field="entryName" title="分录类型名称" width="100"></vxe-table-column>
            <vxe-table-column field="entryDesc" title="分录类型描述" width="100"></vxe-table-column>
            <vxe-table-column field="dataKey" title="取值KEY值" width="100"></vxe-table-column>
            <vxe-table-column field="enableFlag" title="启用标志" width="100"></vxe-table-column>
            <vxe-table-column field="accountType" title="科目类型" width="100"></vxe-table-column>
            <vxe-table-column field="accountCode" title="科目代码" width="100"></vxe-table-column>
            <vxe-table-column field="accountDesc" title="科目名称" width="100"></vxe-table-column>
            <vxe-table-column
              field="natureSideCode"
              title="借贷方向"
              width="100"
            ></vxe-table-column>
            <vxe-table-column field="pkCode" title="过账码代码" width="100"></vxe-table-column>
            <!-- <vxe-table-column field="enteredDrAmount" title="原币借方金额" width="100"></vxe-table-column>
            <vxe-table-column field="enteredCrAmount" title="原币贷方金额" width="100"></vxe-table-column> -->
            <vxe-table-column field="enteredAmount" title="原币金额" width="100"></vxe-table-column>
            <!-- <vxe-table-column field="accountedDrAmount" title="本币借方金额" width="100"></vxe-table-column>
            <vxe-table-column field="accountedCrAmount" title="本币贷方金额" width="100"></vxe-table-column> -->
            <vxe-table-column
              field="accountedAmount"
              title="本币金额"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="profitCenterCode"
              title="利润中心"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="profitCenterName"
              title="利润中心名称"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="costCenterCode"
              title="成本中心"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="costCenterName"
              title="成本中心名称"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="cashflowTransactionCode"
              title="现金流量事务代码"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="cashflowTransactionName"
              title="现金流量事务名称"
              width="100"
            ></vxe-table-column>
            <vxe-table-column field="currencyCode" title="币种代码" width="100"></vxe-table-column>
            <vxe-table-column field="exchangeRate" title="汇率" width="100"></vxe-table-column>
            <vxe-table-column field="summary" title="摘要" width="100"></vxe-table-column>
            <vxe-table-column
              field="sglCode"
              title="特别总账标识代码"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="bankAccountNum"
              title="银行账户号码"
              width="100"
            ></vxe-table-column>
            <vxe-table-column field="bankName" title="开户行名称" width="100"></vxe-table-column>
            <vxe-table-column
              field="partnerCode"
              title="合作伙伴编码"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="partnerZhName"
              title="合作伙伴中文名称"
              width="100"
            ></vxe-table-column>
            <vxe-table-column field="customerCode" title="客户" width="100"></vxe-table-column>
            <vxe-table-column field="supplierCode" title="供应商" width="100"></vxe-table-column>
            <vxe-table-column
              field="externalCustomerCode"
              title="外部客户"
              width="100"
            ></vxe-table-column>
            <vxe-table-column field="maturityDate" title="到期日" width="100"></vxe-table-column>
            <vxe-table-column field="loanNature" title="借款性质" width="100"></vxe-table-column>
            <vxe-table-column field="entityDataId" title="来源行id" width="100"></vxe-table-column>
            <vxe-table-column
              field="accountCondition"
              title="取值逻辑"
              width="100"
            ></vxe-table-column>
            <vxe-table-column field="taxCode" title="税码" width="100"></vxe-table-column>
            <vxe-table-column field="assignmentNo" title="分配号" width="100"></vxe-table-column>
            <vxe-table-column field="materialCode" title="物料号" width="100"></vxe-table-column>
            <vxe-table-column field="businessUnit" title="单位" width="100"></vxe-table-column>
            <vxe-table-column field="businessQuantity" title="数量" width="100"></vxe-table-column>
            <vxe-table-column field="batchNo" title="批次/评估类型" width="100"></vxe-table-column>
            <vxe-table-column field="orderNo" title="采购销售订单号" width="100"></vxe-table-column>
            <vxe-table-column
              field="orderDetailNo"
              title="采购销售订单行号"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="productCategory"
              title="商品分类"
              width="100"
            ></vxe-table-column>
            <vxe-table-column
              field="externalContractNo"
              title="外部合同号"
              width="100"
            ></vxe-table-column>
            <vxe-table-column field="invoiceNo" title="发票号" width="100"></vxe-table-column>
          </vxe-table>

          <vxe-modal
            v-model="showEdit"
            :title="selectRow ? '编辑&保存' : '新增&保存'"
            width="1200"
            :loading="submitLoading"
            resize
            destroy-on-close
          >
            <base-form
              v-model="entryData"
              :options="entryDataOptions"
              ref="entryData"
              label-width="100px"
            ></base-form>
            <el-button
              type="primary"
              @click="submitEvent()"
              :loading="loading"
              class="fixed-bottom-btn"
              >提交</el-button
            >
          </vxe-modal>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div v-if="$route.query.type != 'query'" class="fixed-bottom-btnList">
      <el-button type="primary" @click="save()" :loading="loading" class="fixed-bottom-btn"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import API from '@/api/financeCenter/aeVoucherTemplate';
  import COMMON_API from '@/api/financeCenter/commonVoucherTemplate';
  // import { resolve, reject } from 'q';

  export default {
    name: 'templateAdd',
    components: {
      baseForm,
    },
    data() {
      return {
        loading: false,
        activeNames: ['1', '2'],
        submitLoading: false,
        tableData: [],
        selectRow: null,
        showEdit: false,
        applicationList: [],
        entityList: [],
        eventList: [],
        allEntityList: [],
        allEventList: [],
        baseData: {
          id: null,
          applicationCode: '', // 业务模块代码
          entityCode: '', // 实体代码
          eventCode: '', // 事件分类代码
          templateCode: '', // 事件类型代码
          templateName: '', // 事件类型名称
          templateDesc: '', // 事件类型描述
          accountCondition: '', // 取值逻辑
          enableFlag: '', // 启用标志Y启用，N不启用
          accountingFlag: '', // 是否需入账Y是，N否
          ledgerCode: '', // 取值表达式
          voucherType: '', // 取值表达式
          voucherAmount: '', // 凭证总金额
          currencyCode: '', // 取值表达式
          exchangeType: '', // 取值表达式
          exchangeRate: '', // 取值表达式
          exchangeDate: '', // 取值表达式
          postDate: '', // 取值表达式
          calendarPeriod: '', // 取值表达式
          summary: '', // 取值表达式,采用模板表达式,比如'单据号 ' + docNo
          entityDataId: '', // 取值表达式
          entityDataNo: '', // 取值表达式
          transactionNum: '', // 取值表达式
          referenceNo: '', // 参考号
          companyCurrencyCode: '', // 公司本位币币种
          voucherCompanyCode: '', // 凭证公司代码
          voucherCompanyName: '', // 凭证公司名称
          sapCompanyCode: '', // sap公司代码
        },
        entryData: {
          entryCode: null,
          entryName: null,
          entryDesc: null,
          dataKey: null,
          accountCondition: null,
          enableFlag: null,
          accountCode: null,
          accountDesc: null,
          natureSideCode: null,
          //  enteredDrAmount:null,
          //  enteredCrAmount:null,
          enteredAmount: null,
          //  accountedDrAmount:null,
          //  accountedCrAmount:null,
          accountedAmount: null,
          profitCenterCode: null,
          profitCenterName: null,
          costCenterCode: null,
          costCenterName: null,
          cashflowTransactionCode: null,
          cashflowTransactionName: null,
          currencyCode: null,
          exchangeRate: null,
          summary: null,
          bankAccountNum: null,
          bankName: null,
          partnerCode: null,
          partnerZhName: null,
          customerCode: null,
          supplierCode: null,
          externalCustomerCode: null,
          maturityDate: null,
          loanNature: null,
          entityDataId: null,
          pkCode: null,
          sglCode: null,
          taxCode: null,
          assignmentNo: null,
          materialCode: null,
          businessUnit: null,
          businessQuantity: null,
          batchNo: null,
          orderNo: null,
          orderDetailNo: null,
          productCategory: null,
          externalContractNo: null,
          invoiceNo: null,
        },
        formRules: {
          entryCode: [{ required: true, message: '请输入名称' }],
        },
        rules() {},
        entryDataOptions: [
          { prop: 'entryCode', label: '分录类型代码', type: 'input', maxlength: 128 },
          { prop: 'entryName', label: '分录类型名称', type: 'input', maxlength: 128 },
          { prop: 'entryDesc', label: '分录类型描述', type: 'input', maxlength: 128 },
          { prop: 'dataKey', label: '取值KEY值', type: 'input', maxlength: 128 },
          { prop: 'enableFlag', label: '启用标志', type: 'input', maxlength: 128 },
          { prop: 'accountType', label: '科目类型', type: 'input', maxlength: 128 },
          { prop: 'accountCode', label: '科目代码', type: 'input', maxlength: 128 },
          { prop: 'accountDesc', label: '科目名称', type: 'input', maxlength: 128 },
          { prop: 'natureSideCode', label: '借贷方向', type: 'input', maxlength: 128 },
          { prop: 'pkCode', label: '过账码代码', type: 'input', maxlength: 128 },
          // {prop: "enteredDrAmount" ,label: "原币借方金额" , type: 'input', maxlength: 128 },
          // {prop: "enteredCrAmount" ,label: "原币贷方金额" , type: 'input', maxlength: 128 },
          { prop: 'enteredAmount', label: '原币金额', type: 'input', maxlength: 128 },
          // {prop: "accountedDrAmount" ,label: "本币借方金额" , type: 'input', maxlength: 128 },
          // {prop: "accountedCrAmount" ,label: "本币贷方金额" , type: 'input', maxlength: 128 },
          { prop: 'accountedAmount', label: '本币金额', type: 'input', maxlength: 128 },
          { prop: 'profitCenterCode', label: '利润中心', type: 'input', maxlength: 128 },
          { prop: 'profitCenterName', label: '利润中心名称', type: 'input', maxlength: 128 },
          { prop: 'costCenterCode', label: '成本中心', type: 'input', maxlength: 128 },
          { prop: 'costCenterName', label: '成本中心名称', type: 'input', maxlength: 128 },
          {
            prop: 'cashflowTransactionCode',
            label: '现金流量事务代码',
            type: 'input',
            maxlength: 128,
          },
          {
            prop: 'cashflowTransactionName',
            label: '现金流量事务名称',
            type: 'input',
            maxlength: 128,
          },
          { prop: 'currencyCode', label: '币种代码', type: 'input', maxlength: 128 },
          { prop: 'exchangeRate', label: '汇率', type: 'input', maxlength: 128 },
          { prop: 'summary', label: '摘要', type: 'input', maxlength: 128 },
          { prop: 'sglCode', label: '特别总账标识代码', type: 'input', maxlength: 128 },
          { prop: 'bankAccountNum', label: '银行账户号码', type: 'input', maxlength: 128 },
          { prop: 'bankName', label: '开户行名称', type: 'input', maxlength: 128 },
          { prop: 'partnerCode', label: '合作伙伴编码', type: 'input', maxlength: 128 },
          { prop: 'partnerZhName', label: '合作伙伴中文名称', type: 'input', maxlength: 128 },
          { prop: 'customerCode', label: '客户', type: 'input', maxlength: 128 },
          { prop: 'supplierCode', label: '供应商', type: 'input', maxlength: 128 },
          { prop: 'externalCustomerCode', label: '外部客户', type: 'input', maxlength: 128 },
          { prop: 'maturityDate', label: '到期日', type: 'input', maxlength: 128 },
          { prop: 'loanNature', label: '借款性质', type: 'input', maxlength: 128 },
          { prop: 'entityDataId', label: '来源行id', type: 'input', maxlength: 128 },
          { prop: 'accountCondition', label: '取值逻辑', type: 'input', maxlength: 128 },
          { prop: 'taxCode', label: '税码', type: 'input', maxlength: 128 },
          { prop: 'assignmentNo', label: '分配号', type: 'input', maxlength: 128 },
          { prop: 'materialCode', label: '物料号', type: 'input', maxlength: 128 },
          { prop: 'businessUnit', label: '单位', type: 'input', maxlength: 128 },
          { prop: 'businessQuantity', label: '数量', type: 'input', maxlength: 128 },
          { prop: 'batchNo', label: '批次/评估类型', type: 'input', maxlength: 128 },
          { prop: 'orderNo', label: '采购销售订单号', type: 'input', maxlength: 128 },
          { prop: 'orderDetailNo', label: '采购销售订单行号', type: 'input', maxlength: 128 },
          { prop: 'productCategory', label: '商品分类', type: 'input', maxlength: 128 },
          { prop: 'externalContractNo', label: '外部合同号', type: 'input', maxlength: 128 },
          { prop: 'invoiceNo', label: '发票号', type: 'input', maxlength: 128 },
          {
            align: 'center',
            span: 24,
            titleAlign: 'left',
            itemRender: {
              name: '$buttons',
              children: [
                { props: { type: 'submit', content: '提交', status: 'primary' } },
                { props: { type: 'reset', content: '重置' } },
              ],
            },
          },
        ],
      };
    },
    created() {},
    computed: {
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            type: 'select',
            label: '业务模块代码',
            options: this.applicationList,
            prop: 'applicationCode',
            valueKey: 'applicationCode',
            labelKey: 'applicationName',
            clearable: true,
          }, //业务模块代码
          {
            type: 'select',
            label: '实体代码',
            prop: 'entityCode',
            options: this.entityList,
            valueKey: 'entityCode',
            labelKey: 'entityName',
            clearable: true,
          }, //实体代码
          {
            type: 'select',
            label: '事件分类代码',
            prop: 'eventCode',
            options: this.eventList,
            valueKey: 'eventCode',
            labelKey: 'eventName',
            clearable: true,
          }, //事件分类代码
          {
            type: 'input',
            maxlength: 128,
            label: '事件类型代码',
            prop: 'templateCode',
            clearable: true,
          }, //事件类型代码
          {
            type: 'input',
            maxlength: 128,
            label: '事件类型名称',
            prop: 'templateName',
            clearable: true,
          }, //事件类型名称
          {
            type: 'input',
            maxlength: 128,
            label: '事件类型描述',
            prop: 'templateDesc',
            clearable: true,
          }, //事件类型描述
          {
            type: 'textarea',
            label: '取值逻辑',
            prop: 'accountCondition',
            clearable: true,
            span: 24,
          }, //取值逻辑
          {
            type: 'select',
            label: '是否启用',
            prop: 'enableFlag',
            clearable: true,
            options: [
              { value: 'Y', label: '启用' },
              { value: 'N', label: '停用' },
            ],
          },
          {
            type: 'input',
            maxlength: 128,
            label: '是否需入账',
            prop: 'accountingFlag',
            clearable: true,
          }, //是否需入账Y是，N否
          {
            type: 'input',
            maxlength: 128,
            label: '账套代码取值',
            prop: 'ledgerCode',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '凭证类型取值',
            prop: 'voucherType',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '凭证总金额取值',
            prop: 'voucherAmount',
            clearable: true,
          }, //凭证总金额
          {
            type: 'input',
            maxlength: 128,
            label: '币种代码取值',
            prop: 'currencyCode',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '汇率类型取值',
            prop: 'exchangeType',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '汇率取值',
            prop: 'exchangeRate',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '汇率日期取值',
            prop: 'exchangeDate',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '入账日期取值',
            prop: 'postDate',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '期间取值',
            prop: 'calendarPeriod',
            clearable: true,
          }, //取值表达式
          { type: 'input', maxlength: 128, label: '摘要取值', prop: 'summary', clearable: true }, //取值表达式,采用模板表达式,比如'单据号 ' + docNo
          {
            type: 'input',
            maxlength: 128,
            label: '实体单据ID取值',
            prop: 'entityDataId',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '实体单据编号取值',
            prop: 'entityDataNo',
            clearable: true,
          }, //取值表达式
          {
            type: 'input',
            maxlength: 128,
            label: '事务代码取值',
            prop: 'transactionNum',
            clearable: true,
          }, //取值表达式
          { type: 'input', maxlength: 128, label: '参考号', prop: 'referenceNo', clearable: true }, //参考号
          {
            type: 'input',
            maxlength: 128,
            label: '公司本位币币种',
            prop: 'companyCurrencyCode',
            clearable: true,
          }, //公司本位币币种
          {
            type: 'input',
            maxlength: 128,
            label: '凭证公司代码',
            prop: 'voucherCompanyCode',
            clearable: true,
          }, //凭证公司代码
          {
            type: 'input',
            maxlength: 128,
            label: '凭证公司名称',
            prop: 'voucherCompanyName',
            clearable: true,
          }, //凭证公司名称
          {
            type: 'input',
            maxlength: 128,
            label: 'sap公司代码',
            prop: 'sapCompanyCode',
            clearable: true,
          }, //sap公司代码
        ];
      },
    },
    mounted() {
      if (this.$route.query.type) {
        this.getDetail();
      }
      this.getApplicationList();
      this.getEntityList();
      this.getEventList();
    },
    methods: {
      // 请求详情
      getDetail() {
        this.loading = true;
        const params = {
          id: this.$route.query.id,
        };
        this.$axios.post(API.QUERY_AEVOUCHER_TEMPLATE_BY_ID, params).then((res) => {
          if (res.data.code == 0) {
            this.loading = false;
            let data = res.data.data;
            this.baseData = data;
            this.tableData = data.detailList;
          }
        });
      },
      save() {
        let params = {};
        let baseForm = this.baseData;
        if (baseForm) {
          params = {
            ...baseForm,
            detailList: this.$refs.xTable.getTableData().fullData,
          };
        } else {
          return;
        }
        if (this.$route.query.id) {
          params = {
            ...params,
            id: this.$route.query.id,
            detailList: this.$refs.xTable.getTableData().fullData,
          };
        }
        this.saveData(params);
      },
      saveData(params) {
        this.loading = true;
        // 保存提交
        this.$axios.post(API.SAVE_AEVOUCHER_TEMPLATE, params).then((res) => {
          this.loading = false;
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: '保存成功！',
              type: 'success',
            });
            this.returnPath();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      handleChangeBaseData(value, prop) {
        if (prop == 'applicationCode') {
          this.baseData.entityCode = null;
          this.baseData.eventCode = null;
          this.entityList = this.allEntityList.filter(
            (item) => item.applicationCode == value.applicationCode
          );
        } else if (prop == 'entityCode') {
          this.baseData.eventCode = null;
          this.eventList = this.allEventList.filter((item) => item.entityCode == value.entityCode);
          console.info(this.eventList);
        }
      },
      getApplicationList() {
        this.$axios.post(COMMON_API.QUERY_AE_APPLICATION, {}).then((res) => {
          if (res.data.code == 0) {
            this.applicationList = res.data.data;
          }
        });
      },
      getEntityList() {
        this.$axios.post(COMMON_API.QUERY_AE_ENTITY, {}).then((res) => {
          if (res.data.code == 0) {
            this.entityList = res.data.data;
            this.allEntityList = res.data.data;
          }
        });
      },
      getEventList() {
        this.$axios.post(COMMON_API.QUERY_AE_EVENT, {}).then((res) => {
          if (res.data.code == 0) {
            this.eventList = res.data.data;
            this.allEventList = res.data.data;
          }
        });
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/generalAccounting/editVoucherTemplate',
            name: 'editVoucherTemplate',
            meta: {
              keepAlive: true,
            },
          },
          toPath: {
            path: '/generalAccounting/queryVoucherTemplate',
            name: 'queryVoucherTemplate',
            meta: {
              keepAlive: false,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      formatterSex({ cellValue }) {
        let item = this.sexList.find((item) => item.value === cellValue);
        return item ? item.label : '';
      },
      visibleMethod({ data }) {
        return data.flag1 === 'Y';
      },
      cellDBLClickEvent({ row }) {
        this.editEvent(row);
      },
      insertEvent() {
        this.entryData = {
          entryCode: '',
          entryName: '',
          entryDesc: '',
          dataKey: '',
          // accountCondition:'',
          enableFlag: '',
          accountCode: '',
          accountDesc: '',
          natureSideCode: '',
          // enteredDrAmount:'',
          // enteredCrAmount:'',
          enteredAmount: '',
          // accountedDrAmount:'',
          // accountedCrAmount:'',
          accountedAmount: '',
          profitCenterCode: '',
          profitCenterName: '',
          costCenterCode: '',
          costCenterName: '',
          cashflowTransactionCode: '',
          cashflowTransactionName: '',
          currencyCode: '',
          exchangeRate: '',
          summary: '',
          bankAccountNum: '',
          bankName: '',
          partnerCode: '',
          partnerZhName: '',
          customerCode: '',
          supplierCode: '',
          externalCustomerCode: '',
          maturityDate: '',
          loanNature: '',
          entityDataId: '',
          pkCode: '',
          sglCode: '',
          accountCondition: null,
          taxCode: null,
          assignmentNo: null,
          materialCode: null,
          businessUnit: null,
          businessQuantity: null,
          batchNo: null,
          orderNo: null,
          orderDetailNo: null,
          productCategory: null,
          externalContractNo: null,
          invoiceNo: null,
        };
        this.selectRow = null;
        this.showEdit = true;
      },
      editEvent(row) {
        this.entryData = {
          entryCode: row.entryCode,
          entryName: row.entryName,
          entryDesc: row.entryDesc,
          dataKey: row.dataKey,
          accountCondition: row.accountCondition,
          enableFlag: row.enableFlag,
          accountCode: row.accountCode,
          accountDesc: row.accountDesc,
          natureSideCode: row.natureSideCode,
          // enteredDrAmount:row.enteredDrAmount,
          // enteredCrAmount:row.enteredCrAmount,
          enteredAmount: row.enteredAmount,
          // accountedDrAmount:row.accountedDrAmount,
          // accountedCrAmount:row.accountedCrAmount,
          accountedAmount: row.accountedAmount,
          profitCenterCode: row.profitCenterCode,
          profitCenterName: row.profitCenterName,
          costCenterCode: row.costCenterCode,
          costCenterName: row.costCenterName,
          cashflowTransactionCode: row.cashflowTransactionCode,
          cashflowTransactionName: row.cashflowTransactionName,
          currencyCode: row.currencyCode,
          exchangeRate: row.exchangeRate,
          summary: row.summary,
          bankAccountNum: row.bankAccountNum,
          bankName: row.bankName,
          partnerCode: row.partnerCode,
          partnerZhName: row.partnerZhName,
          customerCode: row.customerCode,
          supplierCode: row.supplierCode,
          externalCustomerCode: row.externalCustomerCode,
          maturityDate: row.maturityDate,
          loanNature: row.loanNature,
          entityDataId: row.entityDataId,
          pkCode: row.pkCode,
          sglCode: row.sglCode,
          taxCode: row.taxCode,
          assignmentNo: row.assignmentNo,
          materialCode: row.materialCode,
          businessUnit: row.businessUnit,
          businessQuantity: row.businessQuantity,
          batchNo: row.batchNo,
          orderNo: row.orderNo,
          orderDetailNo: row.orderDetailNo,
          productCategory: row.productCategory,
          externalContractNo: row.externalContractNo,
          invoiceNo: row.invoiceNo,
        };
        this.selectRow = row;
        this.showEdit = true;
      },
      removeEvent(row) {
        this.$XModal.confirm('您确定要删除该数据?').then((type) => {
          if (type === 'confirm') {
            this.$refs.xTable.remove(row);
          }
        });
      },
      submitEvent() {
        this.submitLoading = true;
        setTimeout(() => {
          this.submitLoading = false;
          this.showEdit = false;
          if (this.selectRow) {
            this.$XModal.message({ message: '保存成功', status: 'success' });
            Object.assign(this.selectRow, this.entryData);
          } else {
            this.$XModal.message({ message: '新增成功', status: 'success' });
            this.$refs.xTable.insert(this.entryData);
          }
        }, 500);
      },
    },
  };
</script>
